import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IntegrationRoutingModule } from './integration-routing.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { PagosComponent } from './pagos/pagos.component';
import { SincronizacionSIIGOComponent } from './sincronizacion-siigo/sincronizacion-siigo.component';
import { ViewFEComponent } from './view-fe/view-fe.component';
import { ResourcesModule } from '../resources/resources.module';
import { ToastModule } from 'primeng/toast';
import { ProgressBarModule } from 'primeng/progressbar';
import { DialogModule } from 'primeng/dialog';
import { QrCodeModule } from 'ng-qrcode';


@NgModule({
  declarations: [PagosComponent, SincronizacionSIIGOComponent, ViewFEComponent],
  imports: [
    CommonModule,
    IntegrationRoutingModule,
    ResourcesModule,

    FormsModule, ReactiveFormsModule,
    DropdownModule,
    ButtonModule,
    InputTextModule,
    InputNumberModule,
    ToastModule,
    ProgressBarModule,
    DialogModule,
    QrCodeModule
  ]
})
export class IntegrationModule { }
